import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.0.0-rc.0_react-dom@19.0.0-rc-01172397-20240716_react@19.0.0-rc-01172397-20240716__rea_mbyvsc3bfdkjqldixat2ldmkf4/node_modules/next/dist/client/link.js");
